module.exports = __webpack_public_path__ + "img/RaceSmall.9e8f819c.svg";